import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GipAdmTextForm, GipAdmTextModel } from 'src/app/workflow/admin/gipAdmContentList/gipAdmContentList.model';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { AdminService } from 'src/app/workflow/admin/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-gipAdmText',
  templateUrl: './gipAdmText.component.html',
  styleUrls: ['./gipAdmText.component.css']
})
export class GipAdmTextComponent implements OnInit {

  @Output() public submit = new EventEmitter();
  constructor(
    private shareData: SharingDataService,
    public adminService: AdminService,
    public route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
  ) { }

  modelInput = GipAdmTextForm;
  resourceDefinition;
  urlBase: string = 'admin/V_GIP_TEXT_T';
  isNewForm: boolean = false;
  id: string;
  lang: string;
  isEdit: boolean;
  groupName="GIP_TEXT_T";

  formular = [
    { formControlName: "APPLICATION", hidden: true, editReadonly: true, newReadonly: false, readonly: true },
    { formControlName: "TEXTID", hidden: false, editReadonly: true, newReadonly: false, required: true, readonly: true, inputString: true },
    { formControlName: "LANG", hidden: false, editReadonly: true, newReadonly: false, picklist: "GIP_LANG", readonly: true, required: true },
    { formControlName: "USERNAME", hidden: false, editReadonly: true, newReadonly: false, textArea: true, readonly: true, newRow: true},
    { formControlName: "TEXT", newRow: true, hidden: false, editReadonly: false, newReadonly: false, textArea: true},
    { formControlName: "btn_back", button: true, function: "backToDocenvList", type:"button", newRow: true},
    { formControlName: "btn_save", button: true, function: "btnSaveAction", type:"submit"},
  ];

  ngOnInit(): void {
    this.modelInput.reset();
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);

    this.getUrlParams();

    // if (this.isNewForm)
    //   this.changeToNew();
    // else this.getData();

    console.log(this.isEdit)
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.id != undefined) {
          this.id = params.id;
          this.lang = params.lang;
          this.setReadonly();
        } else this.changeToNew();

        if (params.isEdit != undefined) {
          this.isEdit = params.isEdit;
          this.setReadonly();
        }
      });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
    this.getData();
  }


  changeToEdit() {
    this.isEdit = true;
    this.isNewForm = false;
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
    this.formular.forEach(element => {
      if(element.formControlName == "btn_upload") element.hidden = true;
      if(element.formControlName == "btn_delete") element.hidden = false;
    });
  }

  changeToDisplay() {
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.isNewForm = true;
    this.isEdit = false;
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
    this.modelInput.controls.APPLICATION.setValue("GIP_AUSKUNFT")

    this.formular.forEach(element => {
      if(element.formControlName == "btn_delete") element.hidden = true;
    });
  }

  getData() {
    let urls = [
      `admin/V_GIP_TEXT_T?$filter=TEXTID eq '${this.id}' and LANG eq '${this.lang}'`,
    ];
    var data = this.adminService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var value in this. modelInput.value) {
            if (dataElement == value) {
              this.modelInput.controls[value].setValue(data[0][0][dataElement])
            }
          }
        }
      }
    });
  }

  btnSaveAction() {
    if (this.isNewForm){
      this.postData();
    } else {
      this.updateData();
    }
  }


  backToDocenvList() {
    this.router.navigate([`/gipAdmTextList`]);
  }

  updateData() {
    if(this.modelInput.status == "VALID"){
      let model = new GipAdmTextModel();
      model.fromFormGroupModel(this.modelInput);

      this.adminService.updateData("admin/V_GIP_TEXT_T", model, model.getUpdateMap(), (data) => {
        let response = data;
        this.backToDocenvList();
        console.log(response);
      });
    }
  }

  postData(){
    if(this.modelInput.status == "VALID"){
      let model = new GipAdmTextModel();
      model.fromFormGroupModel(this.modelInput);
      console.log(model)
      let response: any;

      this.adminService.postData("admin/V_GIP_TEXT_T", model, (data) => {
        response = data;
        this.backToDocenvList();
        console.log(response);
      });
    }
  }

  action(action) {
    this[action]();
  }

  onSubmit() {
    this.submit.emit();
  }
}
